import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Tooltip,
	Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";

import { generateColor } from "services/colors";

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Tooltip,
	Legend
);

export default function BarChart({
	title,
	data
}) {

	if (!data || !data.labels || !data.datasets) {
		return null;
	}

	// const hours = Array.from({ length: 24 }, (_, i) =>
	// 	i.toString().padStart(2, "0")
	// );

	const chartData = {
		labels: data.labels,
		datasets: data.datasets.map((dataset, index) => {
			const color = generateColor(index, 'statistics');
			return {
				label: dataset.dataset_label,
				data: dataset.data,
				backgroundColor: color
			}
		})
	};

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		
		plugins: {
			legend: {
                display: data.datasets.length > 1,
            }
			// title: {
			// 	display: true,
			// 	text: chartTitle,
			// 	font: {
			// 		size: 16,
			// 		weight: 'bold',
			// 	},
			// 	padding: {
			// 		top: 10,
			// 		bottom: 20,
			// 	}
			// }
		},
		scales: {
			x: {
				stacked: true,
				title: {
					display: true,
					text: 'Hour',
					font: {
						size: 14,
					}
				},
				grid: {
                    color: 'rgba(200, 200, 200, 0.2)',
                }
			},
			y: { 
				stacked: true, 
				beginAtZero: true,
				// title: {
                //     display: true,
                //     text: 'Count',
                //     font: {
                //         size: 14,
                //     }
                // },
                ticks: {
                    precision: 0,
                },
                grid: {
                    color: 'rgba(200, 200, 200, 0.2)',
                }
			}
		}
	};

	return (
		<div className="card stats-container-height">
			<div className="card-header list-header no-background no-border px-2">
				<h3>{title}</h3>
			</div>
			<div className="card-body p-0">
				<Bar options={options} data={chartData} />
			</div>
		</div>
	);
}